import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconInputForm: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconInputForm"><Path d="M9 21H7.5V3H9V21Z" fill="currentColor"/><Path d="M6 18H2V6H6V18Z" fill="currentColor"/><Path d="M22 18H10.5V6H22V18Z" fill="currentColor"/></CentralIconBase>;
});

export default IconInputForm;
